export const symbols = [
    {
      name: "Belongs To",
      symbol: "∈",
    },
    {
      name: "Null",
      symbol: "∅",
    },
    {
      name: "For All",
      symbol: "∀",
    },
    {
      name: "There Exists",
      symbol: "∃",
    },
    {
      name: "Delta",
      symbol: "δ",
    },
    {
      name: "Conjunction",
      symbol: "∧",
    },
    {
      name: "Disjunction",
      symbol: "∨",
    },
    {
      name: "Negation",
      symbol: "¬",
    },
    {
      name: "Conditional",
      symbol: "→",
    },
    {
      name: "Biconditional",
      symbol: "↔",
    },
    {
      name: "Implication",
      symbol: "⇒",
    },
    {
      name: "Equivalence",
      symbol: "⇔",
    },

    {
      name: "Less then, Equal To",
      symbol: "≤",
    },
    {
      name: "Square Root",
      symbol: "√",
    },

    {
      name: "Subset",
      symbol: "⊆",
    },

    {
      name: "! Belongs To",
      symbol: "∉",
    },
    {
      name: "! Subset of",
      symbol: "⊄",
    },
    {
      name: "Union",
      symbol: "∪",
    },
    {
      name: "Intersection",
      symbol: "∩",
    },
    {
      name: "! Equals To",
      symbol: "≠",
    },
    {
      name: "Sigma",
      symbol: "∑",
    },
    {
      name: "Mu",
      symbol: "μ",
    },
    {
      name: "Alpha",
      symbol: "α",
    },
    {
      name: "Beta",
      symbol: "β",
    },
    {
      name: "Theta",
      symbol: "θ",
    },
    {
      name: "Lambda",
      symbol: "λ",
    },
    {
      name: "Pi",
      symbol: "π",
    },
    {
      name: "Alef",
      symbol: "ℵ",
    },
  ];

  export var shortCuts = [
    {
      shortcut: "\\bt",
      symbol: "∈",
    },
    {
      shortcut: "\\null",
      symbol: "∅",
    },
    {
      shortcut: "\\fa",
      symbol: "∀",
    },
    {
      shortcut: "\\te",
      symbol: "∃",
    },
    {
      shortcut: "\\delta",
      symbol: "δ",
    },
    {
      shortcut: "\\and",
      symbol: "∧",
    },
    {
      shortcut: "\\or",
      symbol: "∨",
    },
    {
      shortcut: "\\not",
      symbol: "¬",
    },
    {
      shortcut: "\\cond",
      symbol: "→",
    },
    {
      shortcut: "\\bicond",
      symbol: "↔",
    },
    {
      shortcut: "\\impl",
      symbol: "⇒",
    },
    {
      shortcut: "\\equi",
      symbol: "⇔",
    },

    {
      shortcut: "\\<=",
      symbol: "≤",
    },
    {
      shortcut: "\\sqr",
      symbol: "√",
    },

    {
      shortcut: "\\sub",
      symbol: "⊆",
    },

    {
      shortcut: "\\!bt",
      symbol: "∉",
    },
    {
      shortcut: "\\!sub",
      symbol: "⊄",
    },
    {
      shortcut: "\\U",
      symbol: "∪",
    },
    {
      shortcut: "\\int",
      symbol: "∩",
    },
    {
      shortcut: "\\!=",
      symbol: "≠",
    },
    {
      shortcut: "\\sigma",
      symbol: "∑",
    },
    {
      shortcut: "\\mu",
      symbol: "μ",
    },
    {
      shortcut: "\\alpha",
      symbol: "α",
    },
    {
      shortcut: "\\beta",
      symbol: "β",
    },
    {
      shortcut: "\\theta",
      symbol: "θ",
    },
    {
      shortcut: "\\lambda",
      symbol: "λ",
    },
    {
      shortcut: "\\pi",
      symbol: "π",
    },
    {
      shortcut: "\\alef",
      symbol: "ℵ",
    },
  ];